// import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
// import jsPDF from 'jspdf';
// import LOGO from '../Assets/test.png';
// import FOOTER from '../Assets/ewe.jpg';
// import { MainWrap } from '../utilities/Shared';

// // Function to load image as base64 for jsPDF (only runs in browser)
// const loadImageAsBase64 = (url) => {
//   return new Promise((resolve, reject) => {
//     if (typeof window === 'undefined') {
//       reject(new Error('Image loading skipped during build'));
//       return;
//     }
//     const img = new Image();
//     img.crossOrigin = 'Anonymous';
//     img.onload = () => {
//       try {
//         const canvas = document.createElement('canvas');
//         canvas.width = img.width;
//         canvas.height = img.height;
//         const ctx = canvas.getContext('2d');
//         ctx.drawImage(img, 0, 0);
//         resolve(canvas.toDataURL('image/png'));
//       } catch (error) {
//         console.error('Error converting image to base64:', error);
//         reject(error);
//       }
//     };
//     img.onerror = (error) => {
//       console.error('Error loading image:', error);
//       reject(error);
//     };
//     img.src = url;
//   });
// };

// // Function to generate PDF using jsPDF
// const generatePDF = async (invoiceData) => {
//   const doc = new jsPDF();

//   // Set default values for missing invoiceData
// //   const defaultData = {
// //     invoiceNumber: invoiceData?.invoiceNumber || '0001',
// //     date: invoiceData?.date,
// //     dueDate: invoiceData?.dueDate,
// //     company: {
// //       name: invoiceData?.company?.name || 'JoAnn Klay | Head Ewe',
// //       address: invoiceData?.company?.address || '11804 Nicklaus Circle, Tampa, Florida 33624',
// //       phone: invoiceData?.company?.phone || '(859) 205-7653',
// //       email: invoiceData?.company?.email || 'JKlay@EweDemand.com',
// //     },
// //     client: {
// //       name: invoiceData?.client?.name || 'Jason Gabay',
// //       address: invoiceData?.client?.address || 'Direct Mail Alliance, 6 MANGROVE PT, ST PETE BEACH, FL 33706-3801',
// //       phone: invoiceData?.client?.phone || 'Phone',
// //     },
// //     items: invoiceData?.items || [
// //       { quantity: 1, description: 'Startup Fee', unitPrice: 500, total: 500.00 },
// //       { quantity: 7, description: 'Standard Mail lists – Presort Paperwork and Electronic Files', unitPrice: 15, total: 105.00 },
// //     ],
// //     comments: invoiceData?.comments || 'This includes the $500 startup fee per the work order agreement along with processing fees for the week of 6/8 through 6/14/2025.',
// //   };

// //   // Load header/footer image
// //   let headerImage = '';
// //   try {
// //     headerImage = await loadImageAsBase64(LOGO);
// //   } catch (error) {
// //     console.error('Failed to load header/footer image:', error);
// //   }

// //   // Add header image
// //   if (headerImage) {
//    doc.addImage(LOGO, 'PNG', 5, 10, 180, 20); // Header image spans page width, adjusted height
// //   }

// //   // Set font and styling
// //   doc.setFont('helvetica', 'normal');
// //   doc.setFontSize(10); // Reduced font size for better fit

// //   // Company Info (Letterhead style, adjusted to start below header image)
// //   doc.text(defaultData.company.name, 10, 40);
// //   doc.text(defaultData.company.address, 10, 45);
// //   doc.text(`Phone: ${defaultData.company.phone}`, 10, 50);
// //   doc.text(`Email: ${defaultData.company.email}`, 10, 55);

// //   // Invoice Header
// //   doc.text('INVOICE', 170, 40); // Adjusted to right side
// //   doc.setFont('helvetica', 'bold');
// //   doc.text(`INVOICE # ${defaultData.invoiceNumber}`, 170, 50);
// //   doc.setFont('helvetica', 'normal');
// //   doc.text(`DATE: ${defaultData.date}`, 170, 60);
// //   doc.text(`DUE DATE: ${defaultData.dueDate}`, 170, 70);

// //   // Client Info
// //   doc.text('TO:', 10, 80);
// //   doc.text(defaultData.client.name, 10, 90);
// //   doc.text(defaultData.client.address, 10, 95);
// //   doc.text(`Phone: ${defaultData.client.phone}`, 10, 100);

// //   // Comments
// //   doc.text('COMMENTS OR SPECIAL INSTRUCTIONS:', 10, 110);
// //   doc.text(defaultData.comments, 10, 115, { maxWidth: 190 }); // Expanded to full width

// //   // Itemized List (Table with borders and multi-line support)
// //   const tableStartY = 130;
// //   const cellWidth = [30, 100, 30, 30]; // Adjusted widths to span ~190mm (10mm to 200mm)
// //   const totalWidth = cellWidth.reduce((sum, w) => sum + w, 0); // 190mm
// //   const cellPadding = 1;
// //   const lineHeight = 5; // Height per line

// //   // Draw table header borders
// //   doc.setFont('helvetica', 'bold');
// //   doc.rect(10, tableStartY - 5, cellWidth[0], 10); // Quantity
// //   doc.text('QUANTITY', 10 + cellPadding, tableStartY + 2);
// //   doc.rect(10 + cellWidth[0], tableStartY - 5, cellWidth[1], 10); // Description
// //   doc.text('DESCRIPTION', 10 + cellWidth[0] + cellPadding, tableStartY + 2);
// //   doc.rect(10 + cellWidth[0] + cellWidth[1], tableStartY - 5, cellWidth[2], 10); // Unit Price
// //   doc.text('UNIT PRICE', 10 + cellWidth[0] + cellWidth[1] + cellPadding, tableStartY + 2);
// //   doc.rect(10 + cellWidth[0] + cellWidth[1] + cellWidth[2], tableStartY - 5, cellWidth[3], 10); // Total
// //   doc.text('TOTAL', 10 + cellWidth[0] + cellWidth[1] + cellWidth[2] + cellPadding, tableStartY + 2);

// //   let rowY = tableStartY + 5;
// //   doc.setFont('helvetica', 'normal');
// //   defaultData.items.forEach((item) => {
// //     const quantityLines = doc.splitTextToSize(item.quantity.toString(), cellWidth[0] - 2 * cellPadding);
// //     const descriptionLines = doc.splitTextToSize(item.description, cellWidth[1] - 2 * cellPadding);
// //     const unitPriceLines = doc.splitTextToSize(`$${item.unitPrice.toString()}`, cellWidth[2] - 2 * cellPadding);
// //     const totalLines = doc.splitTextToSize(`$${item.total.toString()}`, cellWidth[3] - 2 * cellPadding);
// //     const maxLines = Math.max(quantityLines.length, descriptionLines.length, unitPriceLines.length, totalLines.length);
// //     const rowHeight = maxLines * lineHeight;

// //     doc.rect(10, rowY, cellWidth[0], rowHeight); // Quantity
// //     doc.text(quantityLines, 10 + cellPadding, rowY + cellPadding, { maxWidth: cellWidth[0] - 2 * cellPadding });
// //     doc.rect(10 + cellWidth[0], rowY, cellWidth[1], rowHeight); // Description
// //     doc.text(descriptionLines, 10 + cellWidth[0] + cellPadding, rowY + cellPadding, { maxWidth: cellWidth[1] - 2 * cellPadding });
// //     doc.rect(10 + cellWidth[0] + cellWidth[1], rowY, cellWidth[2], rowHeight); // Unit Price
// //     doc.text(unitPriceLines, 10 + cellWidth[0] + cellWidth[1] + cellPadding, rowY + cellPadding, { maxWidth: cellWidth[2] - 2 * cellPadding });
// //     doc.rect(10 + cellWidth[0] + cellWidth[1] + cellWidth[2], rowY, cellWidth[3], rowHeight); // Total
// //     doc.text(totalLines, 10 + cellWidth[0] + cellWidth[1] + cellWidth[2] + cellPadding, rowY + cellPadding, { maxWidth: cellWidth[3] - 2 * cellPadding });

// //     rowY += rowHeight + 2; // Add spacing between rows
// //   });

// //   // Subtotal, Tax, Total with borders
// //   const tableSummaryStartY = rowY + 10;
// //   const subtotal = defaultData.items.reduce((sum, item) => sum + item.total, 0);
// //   const salesTax = (subtotal * 0.07).toFixed(2);
// //   const totalDue = (subtotal + parseFloat(salesTax)).toFixed(2);

// //   doc.rect(150, tableSummaryStartY - 5, 50, 10); // Subtotal label
// //   doc.text('SUBTOTAL', 151, tableSummaryStartY + 2);
// //   doc.rect(150, tableSummaryStartY - 5, 50, 10); // Subtotal value
// //   doc.text(`$${subtotal.toFixed(2)}`, 151, tableSummaryStartY + 2);

// //   doc.rect(150, tableSummaryStartY + 5, 50, 10); // Sales Tax label
// //   doc.text('SALES TAX', 151, tableSummaryStartY + 12);
// //   doc.rect(150, tableSummaryStartY + 5, 50, 10); // Sales Tax value
// //   doc.text(`$${salesTax}`, 151, tableSummaryStartY + 12);

// //   doc.rect(150, tableSummaryStartY + 15, 50, 10); // Total Due label
// //   doc.text('TOTAL DUE', 151, tableSummaryStartY + 22);
// //   doc.rect(150, tableSummaryStartY + 15, 50, 10); // Total Due value
// //   doc.text(`$${totalDue}`, 151, tableSummaryStartY + 22);

// //   // Payment Terms
// //   let paymentTermsY = tableSummaryStartY + 30;
// //   doc.text('Payment Terms:', 10, paymentTermsY);
// //   paymentTermsY += 5;
// //   doc.text('Payment is due within 7 calendar days of the invoice date unless otherwise agreed in writing. A 10% late fee will apply to any invoice not paid within 10 days of the due date.', 10, paymentTermsY, { maxWidth: 190 });

// //   // Additional Message
// //   paymentTermsY += 20;
// //   doc.text('We’re honored to be supporting your campaigns. If you have any questions about this invoice or future jobs, don’t hesitate to reach out. Contact: Chris Carten, (727) 687-9169, chris.carten@lightningpresort.com', 10, paymentTermsY, { maxWidth: 190 });

// //   // Thank You
// //   paymentTermsY += 20;
// //   doc.text('THANK YOU FOR YOUR BUSINESS!', 10, paymentTermsY);

//   // Add footer image
//   doc.addImage(FOOTER, 'PNG', 155, 250, 55, 40);

//   // Generate Blob URL (only in browser)
//   if (typeof window !== 'undefined') {
//     try {
//       const blob = doc.output('blob');
//       const blobUrl = URL.createObjectURL(blob);
//       return { blobUrl, doc };
//     } catch (error) {
//       return { blobUrl: '', doc };
//     }
//   }
//   return { blobUrl: '', doc };
// };

// // Main Joann Component
// const Joann = ({ invoiceData }) => {
//   const [pdfBlobUrl, setPdfBlobUrl] = useState('');
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (typeof window === 'undefined') return;
//     generatePDF(invoiceData)
//       .then(({ blobUrl }) => {
//         if (blobUrl) setPdfBlobUrl(blobUrl);
//        // else setError('Failed to generate PDF preview');
//       })
//       .catch(() => console.log('Failed to generate PDF preview'));

//     return () => {
//       if (pdfBlobUrl) {
//         URL.revokeObjectURL(pdfBlobUrl);
//         setPdfBlobUrl('');
//       }
//     };
//   }, [invoiceData]);

//   const handleDownload = () => {
//     generatePDF(invoiceData)
//       .then(({ doc }) => {
//         doc.save(`Invoice_${invoiceData?.invoiceNumber || '0001'}.pdf`);
//       })
//       .catch(() => setError('Failed to download PDF'));
//   };

//   return (
//     <MainWrap style={{ marginTop: "25px" }}>
//       <div className="p-4 max-w-4xl mx-auto">
//         <div className="mb-4 flex space-x-4">
//           <button onClick={handleDownload} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//             Download Invoice
//           </button>
//           {pdfBlobUrl && (
//             <a href={pdfBlobUrl} target="_blank" rel="noopener noreferrer" className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
//               Open PDF in New Tab
//             </a>
//           )}
//         </div>
//         {error && <div className="text-red-600 text-center mb-4">{error}</div>}
//         {pdfBlobUrl ? (
//           <div className="border rounded-lg overflow-hidden shadow-lg">
//             <iframe key={pdfBlobUrl} src={pdfBlobUrl} title="Invoice PDF Preview" className="w-full h-[700px]" />
//           </div>
//         ) : (
//           <div className="text-gray-500 text-center">Generating PDF preview...</div>
//         )}
//       </div>
//     </MainWrap>
//   );
// };

// Joann.propTypes = {
//   invoiceData: PropTypes.shape({
//     invoiceNumber: PropTypes.string,
//     date: PropTypes.string,
//     dueDate: PropTypes.string,
//     company: PropTypes.shape({
//       name: PropTypes.string,
//       address: PropTypes.string,
//       phone: PropTypes.string,
//     }),
//     client: PropTypes.shape({
//       name: PropTypes.string,
//       address: PropTypes.string,
//       phone: PropTypes.string,
//     }),
//     items: PropTypes.arrayOf(
//       PropTypes.shape({
//         quantity: PropTypes.number,
//         description: PropTypes.string,
//         unitPrice: PropTypes.number,
//         total: PropTypes.number,
//       })
//     ),
//     comments: PropTypes.string,
//   }),
// };

// export default Joann;


import React from 'react'
import RFQPrintProfessional from '../Printing/Rfq_Quotes/RFQPrintProfessional';
import { MainWrap } from '../utilities/Shared';

const Joann = () => {
  return (
    <MainWrap>   <RFQPrintProfessional /></MainWrap>
  )
}

export default Joann

